import '@progress/kendo-ui/css/web/kendo.common-material.css';
import '@progress/kendo-ui/css/web/kendo.material.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'jquery-ui/themes/base/all.css';
import './styles/common/common.css';
import './styles/common/input-slider.css';
import './styles/common/page-header.css';
import './styles/common/tooltips.css';
import './styles/reports/drawer-menu.css';
import './styles/reports/report-editor.css';
import './styles/reports/report-grid.css';
import './styles/reports/reports.css';

import 'bootstrap/js/dropdown';
import $ from 'jquery';
import 'knockout-mapping';
import { loadTemplatesAndApplyBindings, uiHelper } from './scripts';
import './scripts/common/dropdown';
import './scripts/common/dropdownComboBox';
import './scripts/common/element';
import './scripts/common/helperFunctions';
import './scripts/common/inputSlider';
import './scripts/common/inputs/DoubleSelect';
import './scripts/common/inputs/MultiSelect';
import './scripts/common/mixins';
import './scripts/common/modalDialog';
import './scripts/common/pageHeader';
import './scripts/common/runAfter';
import './scripts/filters/reportFilterValuesSelector';
import './scripts/reports/checkRollupStatus';
import './scripts/reports/DrillDownMenu';
import './scripts/reports/notify.min';
import './scripts/reports/reportGrid';
import './scripts/reports/reportGridUI';
import './scripts/elasticAPM';

loadTemplatesAndApplyBindings();

$(function () {
    //scripts should be loaded now.....

    kendo.ui.Grid.prototype._positionColumnResizeHandle = function () {
        var that = this,
            indicatorWidth = that.options.columnResizeHandleWidth,
            lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();

        that.thead.add(lockedHead).on("mousemove" + ".kendoGrid", "th", function (e) {
            var th = $(this);

            if (th.hasClass("k-group-cell") || th.hasClass("k-hierarchy-cell")) {
                return;
            }

            function getPageZoomStyle() {
                var docZoom = parseFloat($(document.documentElement).css("zoom"));
                if (isNaN(docZoom)) {
                    docZoom = 1;
                }
                var bodyZoom = parseFloat($(document.body).css("zoom"));
                if (isNaN(bodyZoom)) {
                    bodyZoom = 1;
                }
                return 1;
            }

            var clientX = e.clientX / getPageZoomStyle(),
                winScrollLeft = $(window).scrollLeft(),
                position = th.offset().left + (!kendo.support.isRtl(this.element) ? this.offsetWidth : 0);

            if (clientX + winScrollLeft > position - indicatorWidth && clientX + winScrollLeft < position + indicatorWidth) {
                that._createResizeHandle(th.closest("div"), th);
            } else if (that.resizeHandle) {
                that.resizeHandle.hide();
            } else {
                //if (cursor != null) {
                //    cursor(that.wrapper, "");
                //}

            }
        });
    };
});
